import styled from 'styled-components';

import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { spacing, colors } from 'ui/theme';

import { ORDERED_TABLE_COLUMNS, TABLE_COLUMNS } from '../constants';
import { HeaderRowCell } from './HeaderRowCell';

const labels: Record<TABLE_COLUMNS, string> = {
  [TABLE_COLUMNS.NAME]: 'Name',
  [TABLE_COLUMNS.TYPE]: 'Type',
  [TABLE_COLUMNS.OVERFLOW]: '',
};

const initialSortDirection: Record<string, SORT_DIRECTIONS> = {
  [TABLE_COLUMNS.NAME]: SORT_DIRECTIONS.ASCENDING,
};

const sortable: Record<TABLE_COLUMNS, boolean> = {
  [TABLE_COLUMNS.NAME]: true,
  [TABLE_COLUMNS.TYPE]: true,
  [TABLE_COLUMNS.OVERFLOW]: false,
};

const headerColumns = ORDERED_TABLE_COLUMNS.map((id) => ({
  id,
  label: labels[id],
  initialSortDirection: initialSortDirection[id],
  isSortable: sortable[id],
}));

const BorderBottom = styled.div`
  border-bottom: solid ${spacing.single} ${colors.grey15};
  grid-column: 1 / span ${ORDERED_TABLE_COLUMNS.length};
`;

export const HeaderRow = () => (
  <>
    {headerColumns.map((column) => (
      <HeaderRowCell column={column} key={column.id} />
    ))}
    <BorderBottom data-test="border-bottom" />
  </>
);
